import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=27198252&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=27198252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27198252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27198252')) {
      api.createRecord('27198252', component.options)
    } else {
      api.reload('27198252', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=27198252&scoped=true&", function () {
      api.rerender('27198252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2776JM2YTu8JG/JS/comp/DocBox.vue"
export default component.exports